export default __webpack_public_path__ + "images/0B.ce06831.png";